import {
    SAVING_ALLOCADIA_INTEGRATION_REQUEST, SAVING_ALLOCADIA_INTEGRATION_SUCCEDDED, SAVING_ALLOCADIA_INTEGRATION_FAILED, 
    FETCHING_ALLOCADIA_INTEGRATION_REQUEST, FETCHING_ALLOCADIA_INTEGRATION_SUCCEDDED, FETCHING_ALLOCADIA_INTEGRATION_FAILED,
    FETCHING_ALLOCADIA_BUDGETS_REQUEST , FETCHING_ALLOCADIA_BUDGETS_SUCCEDDED, FETCHING_ALLOCADIA_BUDGETS_FAILED,
    FETCHING_ALLOCADIA_CATEGORIES_REQUEST, FETCHING_ALLOCADIA_CATEGORIES_SUCCEDDED, FETCHING_ALLOCADIA_CATEGORIES_FAILED,
    FETCHING_ALLOCADIA_COLUMNS_REQUEST, FETCHING_ALLOCADIA_COLUMNS_SUCCEDDED, FETCHING_ALLOCADIA_COLUMNS_FAILED, 
    FETCHING_ALLOCADIA_COLUMN_CHOICES_REQUEST,FETCHING_ALLOCADIA_COLUMN_CHOICES_SUCCEDDED, FETCHING_ALLOCADIA_COLUMN_CHOICES_FAILED,
    FETCHING_ALLOCADIA_MAPPING_REQUEST, FETCHING_ALLOCADIA_MAPPING_SUCCEDDED, FETCHING_ALLOCADIA_MAPPING_FAILED,
    CREATING_ALLOCADIA_LINE_ITEM_REQUEST,CREATING_ALLOCADIA_LINE_ITEM_SUCCEDDED, CREATING_ALLOCADIA_LINE_ITEM_FAILED,
    SEARCHING_LINE_ITEM,SEARCHING_LINE_ITEM_SUCCEDDED,SEARCHING_LINE_ITEM_FAILED,
    INVALIDATE_LINE_ITEMS 
} from '../../actions/actionTypes';

import { combineReducers } from 'redux';

const initialState = {
  loading: false,
  items : [],
  error : null,
	changes: {
		saving: false,
		error: null
	},
  columns:{
    loading: false,
    items: [],
    error: null
  },
  mapping:{
    loading: false,
    item: null,
    error: null
  },
  lineItems: {
    loading: false,
    item: null,
    error: null
  }
};

function allocadiaIntegrationReducer(state = initialState, action) {
  switch (action.type) {
    case SAVING_ALLOCADIA_INTEGRATION_REQUEST:
    return Object.assign({}, state, {
      ...state,
      changes: {
        ...state.changes,
        saving: true,
        error: null
      }
    })
  case SAVING_ALLOCADIA_INTEGRATION_SUCCEDDED:
    return Object.assign({}, state, {
      ...state,
      changes: {
        ...state.changes,
        saving: false,
        error: null
      }
    })
  case SAVING_ALLOCADIA_INTEGRATION_FAILED:
    return Object.assign({}, state, {
      ...state,
      changes: {
        ...state.changes,
        saving: false,
        error: action.payload
      }
    })

  // case DEACTIVATING_ALLOCADIA_INTEGRATION_REQUEST:
  //   return Object.assign({}, state, {
  //     ...state,
  //     deactivation: {
  //       deactivating: true,
  //       error: null
  //     }
  //   })
  // case DEACTIVATING_ALLOCADIA_INTEGRATION_SUCCEDDED:
  //   return Object.assign({}, state, {
  //     ...state,
  //     deactivation: {
  //       deactivating: false,
  //       error: null
  //     }
  //   })
  // case DEACTIVATING_ALLOCADIA_INTEGRATION_FAILED:
  //   return Object.assign({}, state, {
  //     ...state,
  //     deactivation: {
  //       deactivating: false,
  //       error: action.payload
  //     }
  //   })  
  case FETCHING_ALLOCADIA_INTEGRATION_REQUEST:
    return Object.assign({}, state, {
      ...state,
      changes: {
        ...state.changes,
        loading: true
      }
    }) 
  case FETCHING_ALLOCADIA_INTEGRATION_SUCCEDDED: 
    return Object.assign({}, state, {
      ...state,
      changes: {
        ...state.changes,
        loading: false
      }
    }) 
  case FETCHING_ALLOCADIA_INTEGRATION_FAILED:
    return Object.assign({}, state, {
      ...state,
      changes: {
        ...state.changes,
        loading: false
      }
    }) 
		case FETCHING_ALLOCADIA_BUDGETS_REQUEST:
		  var source = action.payload.source;
      return Object.assign({}, state, {
        ...state,
        ...state.items,
        loading: true,
      })
		case FETCHING_ALLOCADIA_BUDGETS_SUCCEDDED:
      var source = action.payload.source;
      var children = action.payload.children;
      var items = [];
      if(source != null){
        items = state.items.map((item) => {
          return Object.assign({}, item, {
            ...item,
            children: {
              loading: false,
              items: children
            }
          })
          
        });
      }else{
        items = children;
      }

      return Object.assign({}, state, {
        ...state,
        items: items,
        loading: false,
      })
		case FETCHING_ALLOCADIA_BUDGETS_FAILED:
      var source = action.payload.source;
      var error = action.payload.error;
      return Object.assign({}, state, {
        ...state,
        ...state.items,
        loading: false,
      })
    case FETCHING_ALLOCADIA_CATEGORIES_REQUEST:
      return Object.assign({}, state, {
        ...state,
        ...state.items,
      })
		case FETCHING_ALLOCADIA_CATEGORIES_SUCCEDDED:
      var source = action.payload.source;
      var children = action.payload.children;
      var items = [];
      items = state.items.map((item) => {
        return Object.assign({}, item, {
          ...item,
          children: {
            loading: false,
            items: children
          }
        })
      });
    
      return Object.assign({}, state, {
        ...state,
        items: items
      })
		case FETCHING_ALLOCADIA_CATEGORIES_FAILED:
      var error = action.payload.error;
      return Object.assign({}, state, {
        ...state,
        ...state.items
      }) 
    case FETCHING_ALLOCADIA_COLUMNS_REQUEST:
      return Object.assign({}, state, {
        ...state,
        columns: {
          ...state.columns,
          loading: true,
          error: null
        }
      })
    case FETCHING_ALLOCADIA_COLUMNS_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        columns: {
          ...state.columns,
          loading: false,
          items: action.payload,
          error: null
        }
      })
    case FETCHING_ALLOCADIA_COLUMNS_FAILED:
      return Object.assign({}, state, {
        ...state,
        columns: {
          ...state.columns,
          loading: false,
          error: action.payload
        }
      })
    case FETCHING_ALLOCADIA_MAPPING_REQUEST:
      return Object.assign({}, state, {
        ...state,
        mapping: {
          ...state.mapping,
          loading: true
        }
      }) 
    case FETCHING_ALLOCADIA_MAPPING_SUCCEDDED: 
      return Object.assign({}, state, {
        ...state,
        mapping: {
          ...state.mapping,
          item: action.payload,
          loading: false
        }
      }) 
    case FETCHING_ALLOCADIA_INTEGRATION_FAILED:
      return Object.assign({}, state, {
        ...state,
        mapping: {
          ...state.mapping,
          item: null,
          loading: false,
          error: action.payload.error
        }
      }) 
    case CREATING_ALLOCADIA_LINE_ITEM_REQUEST:
      return Object.assign({}, state, {
        ...state,
        mapping: {
          ...state.mapping,
          loading: true,
          error: null
        }
      }) 
    case CREATING_ALLOCADIA_LINE_ITEM_SUCCEDDED: 
      return Object.assign({}, state, {
        ...state,
        mapping: {
          ...state.mapping,
          item: action.payload,
          loading: false,
          error: null
        }
      }) 
    case CREATING_ALLOCADIA_LINE_ITEM_FAILED:
      return Object.assign({}, state, {
        ...state,
        mapping: {
          ...state.mapping,
          loading: false,
          error: action.payload
        }
      })
    case INVALIDATE_LINE_ITEMS:
       return Object.assign({}, state, {
         ...state,         
         lineItems: {
          item: null,
          loading: false,
          error: null
         }         
       })
    case SEARCHING_LINE_ITEM:
      return Object.assign({},state, {
        ...state,
        lineItems: {
          ...state.lineItems,
          item: null,
          loading: true,
          error: null
        }
       
      })
    case SEARCHING_LINE_ITEM_SUCCEDDED:
      var item = action.payload
      return Object.assign({},state, {
        ...state,
        lineItems: {
          ...state.lineItems,
          item: item,
          loading: false,
          error: null
        }
      })
    case SEARCHING_LINE_ITEM_FAILED:
      var error = action.payload.error
      return Object.assign({},state, {
        ...state,
        lineItems:{
          ...state.lineItems,
          loading: false,
          error: error
        }
      })
    default:
      return state
  }
}

export { allocadiaIntegrationReducer };

